import styled from "styled-components";

interface AlarmItemStyleProps {
  $readed?: boolean;
  $active?: boolean;
}

export const AlarmItem = styled.li`
  width: 100%;
  padding: 16px;
  background: ${(props) => props.theme.colors.white100};
  box-shadow: ${(props) => props.theme.shadows.box};
  border-radius: 10px;

  &:active {
    background: ${(props) => props.theme.colors.primary8};
    box-shadow: none;
  }

  a {
    gap: 16px;
    color: ${(props) => props.theme.colors.black100};
    display: flex;
    text-decoration: none;
    flex-direction: column;
  }
`;

export const AlarmTit = styled.div<AlarmItemStyleProps>`
  gap: 6px;
  display: flex;
  margin-bottom: 8px;
  flex-direction: column;

  span {
    color: ${(props) => props.theme.colors.primary100};
    display: flex;
    font-size: 1.3rem;
    font-weight: 700;
    align-items: center;
    justify-content: space-between;

    span {
      color: ${(props) =>
        props.$readed ? props.theme.colors.black38 : props.theme.colors.red100};
      font-size: 1.2rem;
      font-weight: 400;
    }
  }

  div {
    color: ${(props) => props.theme.colors.text4};
    overflow: hidden;
    font-size: 1.6rem;
    line-height: 150%;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const AlarmBody = styled.div<AlarmItemStyleProps>`
  gap: 10px;
  color: ${(props) => props.theme.colors.text4};
  display: flex;
  overflow: hidden;
  font-size: 1.4rem;
  margin-top: 10px;
  font-weight: 400;
  line-height: 140%;
  white-space: pre-line;
  flex-direction: column;

  ${(props) =>
    props.$active
      ? `
      white-space: pre-line;
      text-overflow: initial;
      -webkit-line-clamp: unset;
      -webkit-box-orient: unset;
        `
      : `
        display: -webkit-box;
        overflow: hidden;
        word-break: keep-all;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        `}
`;

export const AlarmDate = styled.span`
  color: ${(props) => props.theme.colors.inputPlaceholder};
  font-size: 1.2rem;
`;
